export let showMethods = {
  random: opts => {
    let interval = opts.showOffersBaseInterval
    let plusInterval = opts.showOffersInterval
    let counter = 0
    let offersContents = $(`#offers-widget .content`)
    let total = offersContents.length

    for (let i = 0; i < total; i++) {
      let timer = setTimeout(() => {
        let index = Math.ceil(Math.random() * offersContents.length) - 1
        let currentItem = $(offersContents[index])
        currentItem.addClass('show-content')

        offersContents.splice($.inArray(offersContents[index], offersContents), 1)

        //zakryti preloaeru, az jsou nabidky nacteny
        counter++
        if(counter == offersContents.length)
          setTimeout(() => {
            $('#offers-widget').addClass('hide-preloader-bg')
          }, 1000) // ms CSS transition

      }, interval)

      interval += plusInterval
    }
  },
  linear: opts => {
    let interval = opts.showOffersBaseInterval
    let plusInterval = opts.showOffersInterval
    let counter = 0
    let offersContents = $(`#offers-widget .item`)
    // let offersContents = $(`#offers-widget .content`)

    offersContents.each((index, item) => {
      let timer = setTimeout(() => {
        if(!$(item).hasClass('test')) {
          $(item).css({
            transition: '1s all',
            opacity: 0,
            visibility: 'hidden'
          })
        }

        $(item).find('.content').addClass('show-content')

        //zakryti preloaeru, az jsou nabidky nacteny
        counter++
        if(counter == offersContents.length)
          setTimeout(() => {
            $('#offers-widget').addClass('hide-preloader-bg')
          }, 1000) // ms CSS transition
      }, interval)

      interval += plusInterval
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/offers/show-methods.js